import { createSlice } from '@reduxjs/toolkit';
import { FTAType, HSCode } from 'types/ftaType';

interface FTAState {
  fta: FTAType;
  ftaList: FTAType[];
  ftaSearchList: FTAType[];
  hsCodes: HSCode[];
}

const initialState: FTAState = {
  fta: {} as FTAType,
  ftaList: [],
  ftaSearchList: [],
  hsCodes: [],
};

const ftaSlice = createSlice({
  name: 'fta',
  initialState,
  reducers: {
    setFTAList(state, action) {
      state.ftaList = action.payload;
    },
    setFTASearchList(state, action) {
      state.ftaSearchList = action.payload;
    },
    setFTA(state, action) {
      state.fta = action.payload;
    },
    setHSCodes(state, action) {
      state.hsCodes = action.payload;
    },
  },
});

export const { setFTAList, setFTASearchList, setFTA, setHSCodes } = ftaSlice.actions;
export default ftaSlice.reducer;
